<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" filterable :disabled="ischeck" @change="searchTable">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')">
                    <el-input v-model.trim="strName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.storeCode')">
                    <el-input v-model.trim="strCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTable()">{{$t('base.search')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Account.storeManage')" ref="LabelContent">
            <div slot="btns">
              <span v-for="acc in access" :key="acc">
                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()" v-if="acc == 'WAREHOUSE001'" style="margin-right:10px">{{$t('base.add')}}</el-button>
              </span>
                <el-button size="small" type="success" @click="exportPartStoreHouse()">{{$t('base.export')}}</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" @selection-change="handleSelectionChange" @sort-change="sortChange" border>
                <el-table-column prop="fcName" :label="$t('Shift.factory')" />
                <el-table-column prop="strName" :label="$t('Account.storeName')" />
                <el-table-column prop="strCode" :label="$t('Account.storeCode')" />
                <el-table-column prop="location" :label="$t('Account.region')" />
                <el-table-column prop="isActive" :label="$t('base.ifEnable')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.isActive == true ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="130">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center; justify-content: center">
                          <span v-for="acc in access" :key="acc">
                            <i class="document el-icon-more" @click="sparePartPosition(scope.row)" v-if="acc == 'WAREHOUSE004'" />
                          </span>
                          <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" v-if="acc == 'WAREHOUSE002'" @click=";(ifAdd = false), updatehOpen(scope.row)" />
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" v-if="acc == 'WAREHOUSE003'" />
                          </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align: left">
            <el-form :model="partStoreHouse" :rules="storeHouse" ref="storeHouse" label-width="100px" class="demo-roleForm">
                <el-form-item :label="$t('Shift.factory')" prop="fcCode">
                    <el-select v-model="partStoreHouse.fcCode" :placeholder="请选择工厂" :disabled="ischeck" clearable filterable @change="selectChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.storeName')" prop="strName">
                    <el-input v-model="partStoreHouse.strName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.storeCode')" prop="strCode">
                    <el-input v-model="partStoreHouse.strCode" :disabled="codeShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.region')" prop="location">
                    <el-input v-model="partStoreHouse.location" :disabled="codeShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.ifEnable')">
                    <el-switch v-model="partStoreHouse.isActive" :active-text="$t('User.Yes')" :inactive-text="$t('User.No')"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updatePartStoreHouse('storeHouse')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'sparePartStoreHouse',
  data () {
    return {
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      fcCode: '',
      strName: '',
      strCode: '',
      tableData: [],
      factoryList: [],
      updateShow: false,
      ifAdd: false,
      codeShow: false,
      partStoreHouse: {
        strCode: '',
        strName: '',
        fcCode: '',
        location: '',
        isActive: ''
      },
      storeHouse: {
        strCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        strName: [
          {
            type: 'string',
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ],
        fcCode: [
          {
            required: true,
            message: this.$t('base.PleaseSelect'),
            trigger: 'blur'
          }
        ],
        location: [
          {
            type: 'string',
            required: true,
            message: this.$t('base.PleaseEnter'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {},
      role: {},
      ischeck: true,
      isclear: false,
      access: []
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.access = JSON.parse(sessionStorage.getItem('auths'))
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0;i < role.length;i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.isclear = true
          this.role = role[i]
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getAllFactory()
    },
    selectChange () {
      this.$forceUpdate()
    },
    sparePartPosition (row) {
      this.$router.push({
        name: 'sparePartPosition',
        params: {
          partPosition: row
        }
      })
    },
    updatehOpen (row) {
      //ifAdd true新增、false编辑
      this.ifAdd ? this.partStoreHouse = {} : this.partStoreHouse = JSON.parse(JSON.stringify(row))
      this.ifAdd ? this.codeShow = false : this.codeShow = true
      this.ifAdd ? this.partStoreHouse.fcCode = this.userInfo.fcCode : ''
      this.updateShow = true
    },
    updatePartStoreHouse (storeHouse) {
      this.$refs[storeHouse].validate((valid) => {
        if (valid) {
            //ifAdd true新增、false编辑
            let options = {
                method: 'POST',
                url: this.ifAdd ? this.$api.addPartStoreHouse : this.$api.editPartStoreHouse,
                data: this.partStoreHouse
            }
          this.$http.request(options).then(response => {
            if (response.status == 100) {
              this.searchTable()
              this.$message.success(this.ifAdd ? this.$t('base.SuccessfullyAdded') : this.$t('base.SuccessfullyUpdated'))
              this.updateShow = false
            } else {
              this.$message.error(response.message)
            }
          })
        } else {
          return false
        }
      })
    },
    //多选框选择 返回当前已选行数据(Array)
    handleSelectionChange (val) {
      console.log(val)
    },
    //从后台获取数据,重新排序
    sortChange (val) {
      // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
      console.log(val)
    },
    //分页
    paginationChange (val) {
      this.searchParams.pageSize = val
      this.searchTable()
    },
    paginationCurrentChange (val) {
      this.searchParams.page = val
      this.searchTable()
    },
    getAllFactory () {
      let options = {
        method: 'get',
        url: this.$api.getAllFactory
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.factoryList = []
          var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          var aa = response.data
          if (this.ischeck) {
            for (var i = 0;i < aa.length;i++) {
              for (let j = 0;j < userInfo.roles.length;j++) {
                if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                  this.factoryList.push(aa[i])
                  this.fcCode = this.userInfo.fcCode
                }
              }
            }
          } else {
            this.factoryList = response.data
          }
        }
        this.searchTable()
      })
    },
    deleteRow (row) {
      this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
        confirmButtonText: this.$t('base.delete'),
        cancelButtonText: this.$t('base.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              params: { spsId: row.spsId },
              url: this.$api.deletePartStoreHouse
            })
            .then(response => {
              this.searchTable()
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.searchTable()
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.searchTable()
          this.$message({
            type: 'info',
            message: this.$t('msg.cancel')
          })
        })
    },
    searchTable () {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page
      }
      if (this.fcCode != undefined && this.fcCode != '') {
        queryParams['fcCode'] = this.fcCode
      }
      if (this.strName != undefined && this.strName != '') {
        queryParams['strName'] = this.strName
      }
      if (this.strCode != undefined && this.strCode != '') {
        queryParams['strCode'] = this.strCode
      }
      let options = {
        method: 'get',
        url: this.$api.getAllPartStoreHouse,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    },
    async exportPartStoreHouse () {
      let queryParams = {}
      queryParams['language'] = this.$t('lang')
      if (this.fcCode != undefined && this.fcCode != '') {
        queryParams['fcCode'] = this.fcCode
      }
      if (this.strName != undefined && this.strName != '') {
        queryParams['strName'] = this.strName
      }
      if (this.strCode != undefined && this.strCode != '') {
        queryParams['strCode'] = this.strCode
      }
      let options = {
        method: 'POST',
        params: queryParams,
        url: this.$api.exportPartStoreHouse,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
        }
      }
      let result = await this.$http.request(options)
      var elink = document.createElement('a')
      elink.download = this.$t('Account.storeInfo')  //设置名称
      elink.style.display = 'none'
      var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)  //追加节点
      elink.click()
      document.body.removeChild(elink)  //删除节点
    }
  }
}
</script>

<style scoped>
</style>
